export const repInitialConfig = {
    "talent_rep_company_mtrx_id": null,
    "talent_id": null,
    "representative_id": null,
    "company_id": null,
    "is_primary": 0,
    "is_delete": 0
}